import $ from 'jquery';

let navigation;
let breadcrumbs;

function init(opts) {

    const defaults = {
        selectors: {
            navigation: '#omni-navigation',
            breadcrumbs: '.breadcrumb'
        }
    };

    const options = $.extend(true, defaults, opts);

    navigation = $(options.selectors.navigation);
    breadcrumbs = $(options.selectors.breadcrumbs);

    if (navigation.length < 1 || breadcrumbs.length < 1) return;

    const $breadcrumbsLinks = $('a', breadcrumbs);

    $breadcrumbsLinks.each(function (i, el) {
        const $link = $(el);
        const dataId = $link.data('id');
        if (dataId) {
            const $navigationTarget = $(`[data-id="${dataId}"]`, navigation);

            $link.on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $navigationTarget.trigger('click');
                // $('body').addClass('preload');
                // setTimeout(function(){
                //     $('body').removeClass('preload');
                // }, 400);
            });
        }
    });
}

export default {
    init
};
